import { getRowKeysFromRowIds } from 'owa-mail-list-store';
import getTableConversationRelation from 'owa-mail-list-store/lib/utils/getTableConversationRelation';
import mailStore from 'owa-mail-store/lib/store/Store';
import { mutatorAction } from 'satcheljs';
export default mutatorAction('updateMessageLikers', function updateMessageLikers(itemId, tableView, isUnlike, userEmailAddress, userDisplayName) {
    var message = mailStore.items.get(itemId);
    // Update the message locally so users see changes right away
    if (!isUnlike) {
        if (message.LikeCount) {
            message.LikeCount++;
        }
        else {
            message.LikeCount = 1;
            message.Likers = [];
        }
        message.Likers.push({
            EmailAddress: userEmailAddress,
            Name: userDisplayName,
            MailboxType: 'Mailbox',
            RoutingType: 'SMTP',
        });
    }
    else {
        if (message.LikeCount > 1) {
            message.LikeCount--;
            message.Likers = message.Likers.filter(function (emailAdresss) { return emailAdresss.EmailAddress !== userEmailAddress; });
        }
        else {
            // If we end up with 0 LikeCount, then we have to nullify these, which means, no Likes
            message.LikeCount = null;
            message.Likers = null;
        }
    }
    // This updates the TableConversationRelation so the total like count for the conversation is accurate on the
    // local store
    if (tableView.tableQuery.listViewType === 0 /* Conversation */ &&
        message.ConversationId) {
        var rowKeys = getRowKeysFromRowIds([message.ConversationId.Id], tableView);
        for (var _i = 0, rowKeys_1 = rowKeys; _i < rowKeys_1.length; _i++) {
            var rowKey = rowKeys_1[_i];
            var tableConversationRelation = getTableConversationRelation(rowKey, tableView.id);
            tableConversationRelation.globalLikeCount += isUnlike ? -1 : 1;
        }
    }
});
//# sourceMappingURL=updateMessageLikers.js.map